import {AXIOS_ERROR_TYPE} from "./constants";
import {clearAuthToken} from "../functions";
import {Store} from "utils/mobx";
import { message } from 'antd';
import {ROUTER_PATH_LOGIN} from "utils/constantsApp";

export const fetchAxiosError = (type: string) => {
    const {RouterStore} = Store
    const {
        setPath,
    } = RouterStore
    switch (type) {
        case AXIOS_ERROR_TYPE.SET_REQUEST_HEADER_ERROR:
            clearAuthToken()
            message.error('用户信息失效，请重新登录。')
            setPath(ROUTER_PATH_LOGIN)
            break;
        default:
            break;
    }
}